export default function AboutPage() {
  return (
    <div style={{ padding: "2rem", direction: "rtl" }}>
      <h1>אודות האתר</h1>
      <p>ברוכים הבאים ל־matay.today – המקום שבו עונים על השאלה: "מתי כדאי?".</p>
      <p>האתר נועד לעזור לכם לקבל החלטות מושכלות בעזרת מידע איכותי ומעודכן.</p>
    </div>
  );
}
